/**
 * Shared date formatting utilities (US format).
 * All functions return a fallback string for null/undefined/invalid input.
 */

// MM/DD/YYYY  (e.g. 03/27/2026)
export const formatDate = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" });
};

// MM/DD/YYYY, hh:mm AM/PM  (e.g. 03/27/2026, 04:01 PM)
export const formatDateTime = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d)) return "—";
  return d.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

// Month DD, YYYY  (e.g. Mar 27, 2026)
export const formatDateShort = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

// Month DD, YYYY hh:mm AM/PM  (e.g. Mar 27, 2026, 04:01 PM)
export const formatDateTimeShort = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d)) return "—";
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
